<template>
<div class="sbwSCBox" v-loading='dataloading'>
    <!-- <div class="dataTop">
        <div class="dataTopName">问题</div>
        <div class="dataTopTime">收藏时间</div>
        <div class="dataTopDelete">操作</div>
    </div> -->

    <div class="dataListBox">
        <div class="dataList" v-if="dataTotal!=0">
            <div class="scDataList" v-for="(item,index) in dataList" :key="index">
                <div class="scDataListTitle" @click="goDetailSBW(item.question,item.questionType,item.answer,item.answerType,item.createTime.slice(0, 10))" v-html='item.question'>
                </div>
                <div class="scDataListBottom">
                    <div class="scDataListTime">时间：<span>{{ item.createTime.slice(0, 10) }}</span></div>
                    <div class="scDataListDelete">
                        <!-- <img v-if="item.isChecked == 2" :src="notGX" alt="" @click="thatHandle(1,index)">
                        <img v-if="item.isChecked == 2" :src="alreadyGX" alt="" @click="thatHandle(0,index)"> -->
                        <img :src="sbwDeleteImg" alt="" @click="deleteHandle(item.id)">
                    </div>
                </div>
            </div>    
        </div>

        <!-- <div class="dataList" v-if="dataTotal!=0">
            <div class="scDataList" v-for="(item,index) in dataList" :key="index">
                <div class="dataListName" @click="goDetailSBW(item.question,item.questionType,item.answer,item.answerType,item.createTime.slice(0, 10))">{{ item.question }}</div>
                <div class="dataListTime">{{ item.createTime.slice(0, 10) }}</div>
                <div class="dataListDeleteBox">
                    <img v-if="item.isChecked == 2" :src="notGX" alt="" @click="thatHandle(1,index)">
                    <img v-if="item.isChecked == 2" :src="alreadyGX" alt="" @click="thatHandle(0,index)">
                    <img :src="userDelete" alt="" @click="deleteHandle(item.id)">
                </div>
            </div>
        </div> -->
        <div v-if="dataTotal==0" class="dataListNot">您还没有收藏随便问相关问答</div>
        <!--分页-->
        <!-- <div v-if="dataTotal>10"> -->
        <div class="fenyeBox">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[10]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dataTotal">
            </el-pagination>
        </div>
  </div>
</div>
  
</template>

<script>
import { API_DATA } from "@/api/index";
import alreadyGX from '@/assets/alreadyGX.png'
import notGX from '@/assets/notGX.png'
import userDelete from '@/assets/userDelete.png'
import sbwDeleteImg from '@/assets/sbwDeleteImg.png'





export default {
  name: 'collectionSBW',
  data () {
    return {
        notGX,
        alreadyGX,
        userDelete,
        sbwDeleteImg,
        dataloading:false,
      //随便问  问答数据
      dataList:[],
      //随便问 问答数据total
      dataTotal:0,
      page:1,
      size:10,
    }
  },
  created(){
    this.getSBWData();
  },
  mounted () {
    
  },
  methods: {
    //获取收藏随便问的数据
    getSBWData(){
        let data = {
            page:this.page,
            limit:this.size
        }
        let tUrl = 'collections/list' ; 
        this.dataloading = true;
        API_DATA.doPostDataSBW(data,tUrl).then(res => {
            if(res.status == 0){
                
                this.dataTotal = res.total;
                let thatData = res.rows;
                //增加被选择参数
                if(this.dataTotal>0){
                    thatData.forEach(function(item,index){
                        item.isChecked = 0
                    })
                }
                this.dataList = thatData;
                this.dataloading = false;
            }else{
                console.log('接口请求出错',res)
                this.dataloading = false;
            }
        })
    },
    //勾选状态
    thatHandle(status,index){
        this.dataList[index].isChecked = status;
    },
    //删除单挑
    deleteHandle(id){
        this.dataloading = true;
        let data = id
        let url = 'collections/delete/';
        API_DATA.doGetDataSBW(data,url).then(res => {
            if(res.status == 0){
                this.dataloading = false;
                this.$message({
                    message:'删除成功',
                    type:'success'
                })
            }else{
                this.dataloading = false;
            }
            this.page = 1;
            this.getSBWData()
        })
    },
    goDetailSBW(wenti,wentiType,huida,huidaType,times){
        let obj = {
            question:wenti,
            answer:huida,
            questionType:wentiType,
            answerType:huidaType,
            dataTimes:times
        }
        this.$store.commit('getSBWDetailInfo',obj)
        this.$router.push('/sbwDetails')
    },
    handleSizeChange(val,num) {
        this.page = val
        this.getSBWData();
    },
    //分页跳转
    handleCurrentChange(val) {
        this.page = val
        this.getSBWData();
    },
  }
}
</script>

<style scoped>

.sbwSCBox{
    border:1px solid #ededed;
    overflow: hidden;
    padding:0 20px;
}
.dataTop{
    border-bottom:1px solid #ededed;
    height: 45px;
    line-height: 45px;
    text-align: center;
}
.dataTopName{
    width:65%;
    float: left;
}
.dataTopTime{
    width:20%;
    float: left;
}
.dataTopDelete{
    width:15%;
    float: left;
}
.scDataList{
    width: 100%;
    border-bottom: 1px solid #ededed;
    overflow: hidden;
    cursor:pointer;
}
.scDataListTitle{
    margin-top:11px;
    margin-bottom:11px;
    line-height: 36px;
    font-size:18p;
    color:#222222;
}
.scDataListBottom{
    color:#888888;
    font-size:16px;
    font-family:MicrosoftYaHei;
    margin-bottom: 20px;
    overflow: hidden;
}
.scDataListTime{
    width:50%;
    float: left;
}
.scDataListDelete{
    width:20px;
    float:right;
}



.dataListName{
    width:65%;
    /* float: left; */
    padding: 20px 0;
    line-height: 25px;
    vertical-align: middle;
    display: inline-block;
}
.dataListTime{
    width:20%;
    /* float: left;     */
    text-align: center;
    padding: 20px 0;
    line-height: 25px;
    vertical-align: middle;
    display: inline-block;
}
.dataListDeleteBox{
   width:15%;
    text-align: center;
    padding: 20px 0;
    line-height: 25px;
    vertical-align: middle;
    display: inline-block; 
}
.dataListDeleteBox img{
    width:18px;
    height:18px;
    margin:0 15px;
}
.fenyeBox{
    text-align: center;
    margin: 15px 0;
}
</style>